import {createContext} from 'react';
import {NavigateOptions, To} from 'react-router-dom';
import type {DiscardCopy} from '@chekin/shared';

export type {DiscardCopy};

export type NavigationTarget = To | number;

export type NavigationGuardConfig = DiscardCopy & {
  when: boolean;
  onDiscard?: () => void;
};

export type NavigationGuardContextValue = {
  registerGuard: (id: string, config: NavigationGuardConfig) => void;
  unregisterGuard: (id: string) => void;
  guardedNavigate: (to: NavigationTarget, options?: NavigateOptions) => void;
  isGuarding: boolean;
};

export const NavigationGuardContext = createContext<
  NavigationGuardContextValue | undefined
>(undefined);
